import React from "react"
import YemenDBCal from "./YemenDBCal"

// import { ResponsiveCalendar } from '@nivo/calendar'
import { Calendar } from '@nivo/calendar'
import yemen2015 from "./images/thumb2015.png"
import yemen2016 from "./images/thumb2016.png"
import yemen2017 from "./images/thumb2017.png"
import yemen2018 from "./images/thumb2018.png"
import yemen2019 from "./images/thumb2019.png"
import legend from "./images/legend.png"
import sound from "./images/soundc.png"
import ReactPlayer from 'react-player'
import Annotation from "./Annotation"
import {
    Container,
    Col,
    Row, Table} from 'reactstrap';
    import Header from "./Header"

    class YemenCalendar extends React.Component{
        constructor() {
            super()
            this.state = {
                count: 0,
                playbackRate: 1.0
            }
            this.setPlaybackRate = this.setPlaybackRate.bind(this);
        }
        setPlaybackRate = e => {
            this.setState({ playbackRate: parseFloat(e.target.value) })
        }
        

        render(){
            const playbackRate = this.state.playbackRate
            return(
    <div>
    <Header/>
    <br/>
    <br/>
    <Container>
    <Row>
        <Col xs="12">
        <br/>
            <h2 className="display-3 text-left">Air raids in 2015</h2>
            <br/>
            <p>At the request of Yemen's internationally recognised Yemeni government, Saudi Arabia formed a military coalition of several Arab nations to assist Yemen's armed forces in fighting the Houthi rebels. </p>
            <p>Although the Saudi-led coalition only intervened in Yemen at the end of March, they carried out more air raids in 2015 than any other year. </p>
            <p>The United States, the United Kingdom and Germany, among several other nations, lent their support to the coalition in the form of weapons, intelligence and training.</p>
            <br/>
        </Col>
    </Row>
    <Row>
        <Col>
            <h3><img src={sound} width="50px" height="auto" alt="equal"/><span style={{lineHeight:"50px"}}>The sounds from above</span></h3>
        </Col>
    </Row>
        <Row>
            <Col xs="9" md="8">
            <p style={{lineHeight:"100%", marginTop:"10px", color:"#f94f33"}}>Every slide represents one day of air raids across Yemen. The colour corresponds to the varying levels of intensity.</p>
            <ReactPlayer
            url='https://player.vimeo.com/external/326170130.sd.mp4?s=e1d6cc25e92f370837e4631fcb65b2e32575f8cd&profile_id=165'
            playbackRate={playbackRate}
            controls
            fileConfig={{ attributes: { poster: 'poster2015.jpg' } }} 
            width='100%'
            height='auto'
            />
            <p>Speed: <button onClick={this.setPlaybackRate} value={1}>1x</button>
                <button onClick={this.setPlaybackRate} value={1.5}>1.5x</button>
                <button onClick={this.setPlaybackRate} value={2}>2x</button></p>
            </Col>
            <Col style={{padding:"1px"}} xs="3" md="4">
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <a href="#2015"><img alt="YemenCalendar" className="img-fluid" src={yemen2015}/></a>
            </Col>

        </Row>
    <Row>
        <Col xs="12">
            <br/>
            <br/>
            <h3>Summary of air raids in 2015</h3>
            <Row>
            <Col xs="12" md="4"><p><strong>Total raids:</strong>  5,431</p></Col>
            <Col xs="12" md="4"><p><strong>Most intense day:</strong> September 6 - 50 raids</p></Col>
            <Col xs="12" md="4"><p><strong>Average raids per day:</strong> 19</p></Col>
            <hr/>
            </Row>
        </Col>
    </Row>
    </Container>
    <Container>
    <hr/>
    <Row>
    <br/>
    <br/>
    <Col id="2015" className="text-left" xs="8"  md="6">
    <Calendar
        data={YemenDBCal}
        from="2015-03-26"
        to="2015-12-31"
        width={225}
        height={1600}
        emptyColor="#eeeeee"
        domain={[0,55]}
        colors={["#ffffe6","#ffffcc","#ffeda0","#fed976","#feb24c","#fd8d3c","#fc4e2a","#e31a1c","#bd0026","#800026","#4d0017"]}
        margin={{"top": 25, "right": 0, "bottom": 50, "left": 20}}
        direction="vertical"
        yearSpacing={0}
        monthBorderWidth={4}
        monthBorderColor="#ffffff"
        monthLegendOffset={5}
        dayBorderWidth={1}
        dayBorderColor="#ffffff"
        legends={[
            {
                "anchor": "bottom-right",
                "direction": "row",
                "translateY": 36,
                "itemCount": 5,
                "itemWidth": 34,
                "itemHeight": 36,
                "itemDirection": "top-to-bottom"
            }
        ]}
    />
    </Col>
    <Col className="annotations text-left" xs="4" md="4">
        <Row>
            <Col><img alt="YemenCalendar" className="img-fluid" src={legend}/><p style={{lineHeight:"100%"}}><small><em>Hover over the calendar to see the number of air raids each day.</em></small></p></Col>
        </Row>
        <Row>
            <Col></Col>
        </Row>
        <Row>
            <Col><Annotation date="26/03/2015" annotateicon="icons/icon4.png" comment="Start of Saudi-led air raids."/></Col>
        </Row>
        <Row>
            <Col><Annotation date="31/03/2015" annotateicon="icons/icon4.png" comment="Air attacks hit a dairy factory outside Hodeidah, killing at least 31 civilians."/></Col>
        </Row>
        <Row>
            <Col></Col>
        </Row>
        <Row>
            <Col><Annotation date="04/07/2015 - 20/07/2015" annotateicon="icons/icon3.png" comment="Eid Al-Fitr"/></Col>
        </Row>
        <Row>
        <Col><Annotation date="27/07/2015" annotateicon="icons/icon1.png" comment="The Saudi-led coalition announces a five-day ceasefire after air raids kill 120 in Mokha, Taiz."/></Col>
        </Row>

        <Row>
        <Col><Annotation date="22/09/2015 - 25/09/2015" annotateicon="icons/icon5.png" comment="Eid Al-Adha"/></Col>
        </Row>
        <Row>
            <Col></Col>
        </Row>
        <Row>
            <Col></Col>
        </Row>
    </Col>
    </Row>
    </Container>
    <hr/>




    <Container>
    <Row>
        <Col xs="12">
        <br/>
            <h2 className="display-3 text-left">Air raids in 2016</h2>
            <br/>
            <p>The war raged on throughout 2016, despite 109 days of peace talks in Kuwait. Additionally, 2016 saw increased criticism of the US's role in the war.  News reports revealing the use of US-made weapons in coalition air raids, as well as rising civilian death tolls, forced the US to renege on certain plans to support the coalition.</p>
                    <br/>
            
        </Col>
    </Row>
    <Row>
        <Col>
            <h3><img src={sound} width="50px" height="auto" alt="equal"/><span style={{lineHeight:"50px"}}>The sounds from above</span></h3>
        </Col>
    </Row>
        <Row>
            <Col xs="9" md="8">
            <p style={{lineHeight:"100%", marginTop:"10px", color:"#f94f33"}}>Every slide represents one day of air raids across Yemen. The colour corresponds to the varying levels of intensity.</p>
            <ReactPlayer
            url='https://player.vimeo.com/external/326170114.sd.mp4?s=61b234f62ff4c99a9a8264fc0c77f3f2505faad1&profile_id=165'
            playbackRate={playbackRate}
            controls
            fileConfig={{ attributes: { poster: 'poster2016.jpg' } }}
            width='100%'
            height='auto'
            />
            <p>Speed: <button onClick={this.setPlaybackRate} value={1}>1x</button>
                <button onClick={this.setPlaybackRate} value={1.5}>1.5x</button>
                <button onClick={this.setPlaybackRate} value={2}>2x</button></p>
            </Col>
            <Col style={{padding:"1px"}} xs="3" md="4">
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <a href="#2016"><img alt="YemenCalendar" className="img-fluid" src={yemen2016}/></a>
            </Col>

        </Row>
    <Row>
        <Col xs="12">
            <br/>
            <br/>
            <h3>Summary of air raids in 2016</h3>
            <Row>
            <Col xs="12" md="4"><p><strong>Total raids:</strong>  5,102</p></Col>
            <Col xs="12" md="4"><p><strong>Most intense day:</strong> August 8 - 52 raids</p></Col>
            <Col xs="12" md="4"><p><strong>Average raids per day:</strong> 14</p></Col>
            <hr/>
            </Row>
        </Col>
    </Row>
    </Container>
    <Container>
    <hr/>
    <Row>
    <br/>
    <br/>
    <Col id="2016" className="text-left" xs="8"  md="6">
    <Calendar
        data={YemenDBCal}
        from="2016-01-01"
        to="2016-12-31"
        width={225}
        height={1600}
        emptyColor="#eeeeee"
        domain={[0,55]}
        colors={["#ffffe6","#ffffcc","#ffeda0","#fed976","#feb24c","#fd8d3c","#fc4e2a","#e31a1c","#bd0026","#800026","#4d0017"]}
        margin={{"top": 25, "right": 0, "bottom": 50, "left": 20}}
        direction="vertical"
        yearSpacing={0}
        monthBorderWidth={4}
        monthBorderColor="#ffffff"
        monthLegendOffset={5}
        dayBorderWidth={1}
        dayBorderColor="#ffffff"
        legends={[
            {
                "anchor": "bottom-right",
                "direction": "row",
                "translateY": 36,
                "itemCount": 5,
                "itemWidth": 34,
                "itemHeight": 36,
                "itemDirection": "top-to-bottom"
            }
        ]}
    />
    </Col>
    <Col className="annotations text-left" xs="4" md="4">
        <Row>
            <Col><img alt="YemenCalendar" className="img-fluid" src={legend}/><p style={{lineHeight:"100%"}}><small><em>Hover over the calendar to see the number of air raids each day.</em></small></p></Col>
        </Row>
        <Row>
            <Col></Col>
        </Row>
        <Row>
            <Col></Col>
        </Row>
        <Row>
        <Col><Annotation date="21/04/2016 - 07/08/2016" annotateicon="icons/icon6.png" comment="Peace talks in Kuwait"/></Col>
        </Row>
        <Row>
        <Col><Annotation date="27/05/2016" annotateicon="icons/icon4.png" comment="The US halts the sale of cluster bombs to the Saudi-led coalition."/></Col>
        </Row>
        <Row>
        <Col></Col>
        </Row>
        <Row>
        <Col><Annotation date="19/09/2016" annotateicon="icons/icon1.png" comment="The Washington Post reports that coalition forces use illegal, US-supplied white phosphorous in air raids."/></Col>
        </Row>
        <Row>
        <Col><Annotation date="08/10/2016" annotateicon="icons/icon12.png" comment="Two air raids hit a funeral in Sanaa, leaving 155 people dead and 525 wounded."/></Col>
        </Row>
        <Row>
        <Col><Annotation date="13/10/2016" annotateicon="icons/icon4.png" comment="Barack Obama backs out of a planned $115bn arms deal with Saudi Arabia."/></Col>
        </Row>
    </Col>
    </Row>
    </Container>
    <hr/>



    <Container>
    <Row>
        <Col xs="12">
        <br/>
            <h2 className="display-3 text-left">Air raids in 2017</h2>
            <br/>
            <p>Coalition forces upped their efforts in 2017 by blockading rebel-held territories, like the vital Hodeidah port, which exacerbated the humanitarian crisis troubling the country. The election of Donald Trump in the US brought increased support for the coalition's efforts.</p>
                    <br/>
            
        </Col>
    </Row>
    <Row>
        <Col>
            <h3><img src={sound} width="50px" height="auto" alt="equal"/><span style={{lineHeight:"50px"}}>The sounds from above</span></h3>
        </Col>
    </Row>
        <Row>
            <Col xs="9" md="8">
            <p style={{lineHeight:"100%", marginTop:"10px", color:"#f94f33"}}>Every slide represents one day of air raids across Yemen. The colour corresponds to the varying levels of intensity.</p>
            <ReactPlayer
            url='https://player.vimeo.com/external/326170074.sd.mp4?s=e96119ac7e8410a778ded6ed076c48e2c7c7cc32&profile_id=165'
            playbackRate={playbackRate}
            controls
            fileConfig={{ attributes: { poster: 'poster2017.jpg' } }}
            width='100%'
            height='auto'
            />
            <p>Speed: <button onClick={this.setPlaybackRate} value={1}>1x</button>
                <button onClick={this.setPlaybackRate} value={1.5}>1.5x</button>
                <button onClick={this.setPlaybackRate} value={2}>2x</button></p>
            </Col>
            <Col style={{padding:"1px"}} xs="3" md="4">
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <a href="#2017"><img alt="YemenCalendar" className="img-fluid" src={yemen2017}/></a>
            </Col>

        </Row>
    <Row>
        <Col xs="12">
            <br/>
            <br/>
            <h3>Summary of air raids in 2017</h3>
            <Row>
            <Col xs="12" md="4"><p><strong>Total raids:</strong> 5,228</p></Col>
            <Col xs="12" md="4"><p><strong>Most intense day:</strong> July 28 - 36 raids</p></Col>
            <Col xs="12" md="4"><p><strong>Average raids per day:</strong> 14</p></Col>
            <hr/>
            </Row>
        </Col>
    </Row>
    </Container>
    <Container>
    <hr/>
    <Row>
    <br/>
    <br/>
    <Col id="2017" className="text-left" xs="8"  md="6">
    <Calendar
        data={YemenDBCal}
        from="2017-01-01"
        to="2017-12-31"
        width={225}
        height={1600}
        emptyColor="#eeeeee"
        domain={[0,55]}
        colors={["#ffffe6","#ffffcc","#ffeda0","#fed976","#feb24c","#fd8d3c","#fc4e2a","#e31a1c","#bd0026","#800026","#4d0017"]}
        margin={{"top": 25, "right": 0, "bottom": 50, "left": 20}}
        direction="vertical"
        yearSpacing={0}
        monthBorderWidth={4}
        monthBorderColor="#ffffff"
        monthLegendOffset={5}
        dayBorderWidth={1}
        dayBorderColor="#ffffff"
        legends={[
            {
                "anchor": "bottom-right",
                "direction": "row",
                "translateY": 36,
                "itemCount": 5,
                "itemWidth": 34,
                "itemHeight": 36,
                "itemDirection": "top-to-bottom"
            }
        ]}
    />
    </Col>
    <Col className="annotations text-left" xs="4" md="4">

        <Row>
        <Col><img alt="YemenCalendar" className="img-fluid" src={legend}/><p style={{lineHeight:"100%"}}><small><em>Hover over the calendar to see the number of air raids each day.</em></small></p></Col>
        </Row>
        <Row>
        <Col><Annotation date="20/01/2017" annotateicon="icons/icon8.png" comment="US President Donald Trump is inaugurated."/></Col>
        </Row>
        <Row>
            <Col></Col>
        </Row>
        <Row>
        <Col><Annotation date="27/05/2017" annotateicon="icons/icon14.png" comment="Trump and Saudi Crown Prince Mohammed bin Salman sign a $110bn arms deal."/></Col>
        </Row>
        <Row>
            <Col></Col>
        </Row>
        <Row>
            <Col></Col>
        </Row>
        <Row>
        <Col><Annotation date="06/11/2017" annotateicon="icons/icon2.png" comment="The coalition imposes a blockade on rebel-held areas after Houthi forces fire a ballistic warhead at Riyadh."/></Col>
        </Row>
        <Row>
            <Col><Annotation date="18/12/2017" annotateicon="icons/icon4.png" comment="Air raid on a car returning from a wedding in Marib kills eight women and two children."/></Col>
        </Row>
    </Col>
    </Row>
    </Container>
    <hr/>



    <Container>
    <Row>
        <Col xs="12">
        <br/>
            <h2 className="display-3 text-left">Air raids in 2018</h2>
            <br/>
            <p>The situation in Yemen drew great attention from the public this year, following several high-publicised air raids that took the lives of women and children, as well as the coalition's apparent use of US-made bombs in these attacks. By the year's end, Saudi Arabia and it's coalition were under intense scrutiny due to the kingdom's involvement in the death of journalist Jamal Khashoggi. Several countries curtailed their support of the coalition's efforts. Meanwhile, the Houthis and the government met for another round of peace talks and agreed upon a ceasefire in the beleaguered city of Hodeidah.</p>
                    <br/>
            
        </Col>
    </Row>
    <Row>
        <Col>
            <h3><img src={sound} width="50px" height="auto" alt="equal"/><span style={{lineHeight:"50px"}}>The sounds from above</span></h3>
        </Col>
    </Row>
        <Row>
            <Col xs="9" md="8">
            <p style={{lineHeight:"100%", marginTop:"10px", color:"#f94f33"}}>Every slide represents one day of air raids across Yemen. The colour corresponds to the varying levels of intensity.</p>
            <ReactPlayer
            url='https://player.vimeo.com/external/326170057.sd.mp4?s=417d8d67535c30053fea9f644c21c725965fb1a5&profile_id=164'
            playbackRate={playbackRate}
            controls
            fileConfig={{ attributes: { poster: 'poster2018.jpg' } }}
            width='100%'
            height='auto'
            />
            <p>Speed: <button onClick={this.setPlaybackRate} value={1}>1x</button>
                <button onClick={this.setPlaybackRate} value={1.5}>1.5x</button>
                <button onClick={this.setPlaybackRate} value={2}>2x</button></p>
            </Col>
            <Col style={{padding:"1px"}} xs="3" md="4">
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <a href="#2018"><img alt="YemenCalendar" className="img-fluid" src={yemen2018}/></a>
            </Col>

        </Row>
    <Row>
        <Col xs="12">
            <br/>
            <br/>
            <h3>Summary of air raids in 2018</h3>
            <Row>
            <Col xs="12" md="4"><p><strong>Total raids:</strong> 3,362</p></Col>
            <Col xs="12" md="4"><p><strong>Most intense day:</strong> March 11 - 28 raids</p></Col>
            <Col xs="12" md="4"><p><strong>Average raids per day:</strong> 9</p></Col>
            <hr/>
            </Row>
        </Col>
    </Row>
    </Container>
    <Container>
    <hr/>
    <Row>
    <br/>
    <br/>
    <Col id="2018" className="text-left" xs="8"  md="6">
    <Calendar
        data={YemenDBCal}
        from="2018-01-01"
        to="2018-12-31"
        width={225}
        height={1600}
        emptyColor="#eeeeee"
        domain={[0,55]}
        colors={["#ffffe6","#ffffcc","#ffeda0","#fed976","#feb24c","#fd8d3c","#fc4e2a","#e31a1c","#bd0026","#800026","#4d0017"]}
        margin={{"top": 25, "right": 0, "bottom": 50, "left": 20}}
        direction="vertical"
        yearSpacing={0}
        monthBorderWidth={4}
        monthBorderColor="#ffffff"
        monthLegendOffset={5}
        dayBorderWidth={1}
        dayBorderColor="#ffffff"
        legends={[
            {
                "anchor": "bottom-right",
                "direction": "row",
                "translateY": 36,
                "itemCount": 5,
                "itemWidth": 34,
                "itemHeight": 36,
                "itemDirection": "top-to-bottom"
            }
        ]}
    />
    </Col>
    <Col className="annotations text-left" xs="4" md="4">
        <Row>
        <Col><img alt="YemenCalendar" className="img-fluid" src={legend}/><p style={{lineHeight:"100%"}}><small><em>Hover over the calendar to see the number of air raids each day.</em></small></p></Col>
        </Row>
        <Row>
            <Col></Col>
        </Row>
        <Row>
            <Col></Col>
        </Row>

        <Row>
        <Col><Annotation date="25/04/2018" annotateicon="icons/icon10.png" comment="Coalition air attacks on a wedding in Saada kills 22 people."/></Col>
        </Row>
        <Row>
            <Col></Col>
        </Row>
        <Row>
        <Col></Col>
        </Row>
        <Row>
        <Col><Annotation date="09/08/2018" annotateicon="icons/icon11.png" comment="An air raid hits a school bus in Sadah, killing 40 children."/></Col>
        </Row>
        <Row>
        <Col><Annotation date="10/11/2018" annotateicon="icons/icon15.png" comment="The US ceases efforts for mid-air refuelling of coalition planes."/></Col>
        </Row>
        <Row>
        <Col><Annotation date="06/12/2018 - 13/12/2018" annotateicon="icons/icon6.png" comment="Sweden peace talks"/></Col>
        </Row>
        <Row>
        <Col><Annotation date="12/12/2018" annotateicon="icons/icon7.png" comment="The US Senate approves a resolution to suspend weapons sales to coalition forces."/></Col>
        </Row>
        
    </Col>
    </Row>
    </Container>
    <hr/>



    <Container>
    <Row>
        <Col xs="12">
        <br/>
            <h2 className="display-3 text-left">Air raids in 2019</h2>
            <br/>
            
        </Col>
    </Row>
    <Row>
        <Col>
            <h3><img src={sound} width="50px" height="auto" alt="equal"/><span style={{lineHeight:"50px"}}>The sounds from above</span></h3>
        </Col>
    </Row>
        <Row>
            <Col xs="9" md="8">
            <p style={{lineHeight:"100%", marginTop:"10px", color:"#f94f33"}}>Every slide represents one day of air raids across Yemen. The colour corresponds to the varying levels of intensity.</p>
            <ReactPlayer
            url='https://player.vimeo.com/external/326170023.sd.mp4?s=0bd359a2758a58edaf03c33bc42244f678f814df&profile_id=165'
            playbackRate={playbackRate}
            controls
            fileConfig={{ attributes: { poster: 'poster2019.jpg' } }}
            width='100%'
            height='auto'
            />
            <p>Speed: <button onClick={this.setPlaybackRate} value={1}>1x</button>
                <button onClick={this.setPlaybackRate} value={1.5}>1.5x</button>
                <button onClick={this.setPlaybackRate} value={2}>2x</button></p>
            </Col>
            <Col style={{padding:"1px"}} xs="3" md="4">
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <a href="#2019"><img alt="YemenCalendar" className="img-fluid" src={yemen2019}/></a>
            </Col>

        </Row>
    <Row>
        <Col xs="12">
            <br/>
            <br/>
            <h3>Summary of air raids so far in 2019 (Up to January 31)</h3>
            <Row>
            <Col xs="12" md="4"><p><strong>Total raids:</strong> 155</p></Col>
            <Col xs="12" md="4"><p><strong>Most intense day:</strong> January 30 - 12 raids</p></Col>
            <Col xs="12" md="4"><p><strong>Average raids per day:</strong> 5</p></Col>
            <hr/>
            </Row>
        </Col>
    </Row>
    </Container>
    <Container>
    <hr/>
    <Row>
    <br/>
    <br/>
    <Col id="2019" className="text-left" xs="8"  md="6">
    <Calendar
        data={YemenDBCal}
        from="2019-01-01"
        to="2019-01-31"
        width={225}
        height={1600}
        emptyColor="#eeeeee"
        domain={[0,55]}
        colors={["#ffffe6","#ffffcc","#ffeda0","#fed976","#feb24c","#fd8d3c","#fc4e2a","#e31a1c","#bd0026","#800026","#4d0017"]}
        margin={{"top": 25, "right": 0, "bottom": 50, "left": 20}}
        direction="vertical"
        yearSpacing={0}
        monthBorderWidth={4}
        monthBorderColor="#ffffff"
        monthLegendOffset={5}
        dayBorderWidth={1}
        dayBorderColor="#ffffff"
        legends={[
            {
                "anchor": "bottom-right",
                "direction": "row",
                "translateY": 36,
                "itemCount": 5,
                "itemWidth": 34,
                "itemHeight": 36,
                "itemDirection": "top-to-bottom"
            }
        ]}
    />
    </Col>
    <Col className="annotations text-left" xs="4" md="4">
        <Row>
        <Col><img alt="YemenCalendar" className="img-fluid" src={legend}/><p style={{lineHeight:"100%"}}><small><em>Hover over the calendar to see the number of air raids each day.</em></small></p></Col>
        </Row>
        <Row>
            <Col></Col>
        </Row>
    </Col>
    </Row>
    </Container>
    </div>
    )
    }
}
export default YemenCalendar